import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class IconHelper extends Component {
  static propTypes = {
    style: PropTypes.object,
    postfix: PropTypes.string,
  }

  render() {
    const { postfix, style } = this.props

    return (
      <i
        style={style}
        className={`ico ico--${postfix}`}
      />
    )
  }
}
